import Service, { service } from '@ember/service'
import ErrorHandler from 'teacher-ui-client/utils/error-handler'
import type { Log } from '@blakeelearning/log'
import type { IntlService } from 'ember-intl'

/**
 * This small service takes care of injection our services into the errorHandler util
 */
export default class ErrorHandlerService extends Service {
  @service log!: Log

  @service intl!: IntlService

  /**
   * Creates an instance of an ErrorHandler
   * @param {String} identifierKey - This key maps to a property of the server error object. eg: detail, source
   * @return {ErrorHandler}
   */
  create(identifierKey = 'detail') {
    const { intl, log } = this
    return new ErrorHandler({ intl, log }, identifierKey)
  }
}

declare module '@ember/service' {
  interface Registry {
    'error-handler': ErrorHandlerService
  }
}
